import { providerRequestsTyped } from "@/api/(requests)/providerTyped";
import { UUID } from "@/core/types";

export type UpdateProviderProfileVariables = {
  preferences?: Record<string, unknown>;
};

export async function updateProviderProfile({
  data,
  providerId,
}: {
  data: UpdateProviderProfileVariables;
  providerId?: UUID;
}): Promise<void> {
  return providerRequestsTyped.update_profile({ data, providerId });
}
